import { render, staticRenderFns } from "./AllEventsPagination.vue?vue&type=template&id=e984f2fe&scoped=true&"
import script from "./AllEventsPagination.vue?vue&type=script&lang=js&"
export * from "./AllEventsPagination.vue?vue&type=script&lang=js&"
import style0 from "./AllEventsPagination.vue?vue&type=style&index=0&id=e984f2fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e984f2fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VPagination,VRow})
